import { c } from 'react-compiler-runtime';
import { Announce } from './Announce.js';
import { jsx } from 'react/jsx-runtime';

function AriaStatus(t0) {
  const $ = c(8);
  let children;
  let rest;
  let t1;
  if ($[0] !== t0) {
    ({
      announceOnShow: t1,
      children,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = rest;
    $[3] = t1;
  } else {
    children = $[1];
    rest = $[2];
    t1 = $[3];
  }
  const announceOnShow = t1 === undefined ? false : t1;
  let t2;
  if ($[4] !== announceOnShow || $[5] !== children || $[6] !== rest) {
    t2 = /*#__PURE__*/jsx(Announce, {
      ...rest,
      announceOnShow: announceOnShow,
      politeness: "polite",
      children: children
    });
    $[4] = announceOnShow;
    $[5] = children;
    $[6] = rest;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}

export { AriaStatus };
